var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tab"},_vm._l((_vm.visibleList),function(ref,index){
var title = ref.title;
var url = ref.url;
var perm = ref.perm;
return _c('li',{key:index,class:{ active: _vm.$route.path == url },on:{"click":function($event){return _vm.$router.push(url)}}},[_vm._v("\n    "+_vm._s(title)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }